import SafetyAnchorPointListModelBase from '../_generated/modelBases/safety-anchor-point-list-model-base';

export default class SafetyAnchorPointListModel extends SafetyAnchorPointListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
